export default {
    'preview.download.pdf': 'Download PDF'
};
